import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalStorageService } from './service/local-storage.service';
import { UserPreferencesService } from './service/user-preferences.service';
import { BaseComponent } from './components/base.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { LocalizationService } from './service/localization.service';
import { AuthorizationService } from './service/authorization.service';
import { TitleDirective } from './directives/title.directive';
import { BgDirective } from './directives/bg.directive';
import { TextColorDirective } from './directives/text-color.directive';
import { TokenService } from './service/token.service';
import { RefreshTokenService } from './service/refresh-token.service';
import { ErrorLogService } from './service/error-log.service';
import { ActionListItemComponent } from './components/action-list-item/action-list-item.component';
import { ActionsService } from './service/actions.service';
import { IssuesService } from './service/issues.service';
import { PhotoViewerService } from './components/photo-viewer/photo-viewer.service';
import { ActionAddEditModalComponent } from './components/action-add-edit-modal/action-add-edit-modal.component';
import { ChappsCommonAngularLibraryModule } from '@npm.chapps.com/chapps.common.angular.library';
import { InterventionTeamsService } from './service/intervention-teams.service';
import { DeleteConfirmationModalComponent } from './components/delete-confirmation-modal/delete-confirmation-modal.component';
import { EnumTranslatePipe } from './enum-translate-pipe';
import { IssueListItemComponent } from './components/issue-list-item/issue-list-item.component';
import { ContactsService } from './service/contacts.service';
import { PhotoViewerComponent } from './components/photo-viewer/photo-viewer.component';
import { AppAvailableLanguagesService } from './service/app-available-languages.service';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { HttpHeadersService } from './service/http-headers.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../../http/auth.interceptor';
import { AccountSiteService } from './service/account-site.service';
import { AuthenticationService } from './service/authentication.service';
import { TimezoneInterceptor } from 'src/app/http/timezone.interceptor';
import { BadgeColorByActionStatusPipe } from './pipes/badge-color-by-action-status.pipe';
import { AddressFormatService } from './service/address-format.service';
import { OfflinePageComponent } from './components/offline-page/offline-page.component';
import { UpdateModalComponent } from './components/update-modal/update-modal.component';
import { BuildingListItemComponent } from './components/building-list-item/building-list-item.component';
import { ActionDetailModalComponent } from './components/action-detail-modal/action-detail-modal.component';
import {ActionIconComponent} from './components/action-icon/action-icon.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import { DropdownSelectionComponent } from './components/dropdown-selection/dropdown-selection.component';
import { StatusContextualMenuComponent } from './components/status-contextual-menu/status-contextual-menu.component';
import {MatMenuModule} from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    MDBBootstrapModulesPro,
    ReactiveFormsModule,
    ChappsCommonAngularLibraryModule,
    AngularSvgIconModule,
    MatMenuModule,
  ],
  declarations: [
    BaseComponent,
    DeleteConfirmationModalComponent,
    TitleDirective,
    BgDirective,
    TextColorDirective,
    ActionListItemComponent,
    ActionAddEditModalComponent,
    IssueListItemComponent,
    EnumTranslatePipe,
    PhotoViewerComponent,
    AddressFormComponent,
    BadgeColorByActionStatusPipe,
    OfflinePageComponent,
    UpdateModalComponent,
    BuildingListItemComponent,
    ActionDetailModalComponent,
    ActionIconComponent,
    DropdownSelectionComponent,
    StatusContextualMenuComponent,
  ],
    exports: [
        BaseComponent,
        DeleteConfirmationModalComponent,
        TitleDirective,
        BgDirective,
        TextColorDirective,
        ActionListItemComponent,
        ActionAddEditModalComponent,
        IssueListItemComponent,
        EnumTranslatePipe,
        PhotoViewerComponent,
        AddressFormComponent,
        DeleteConfirmationModalComponent,
        BadgeColorByActionStatusPipe,
        BuildingListItemComponent,
        ActionIconComponent,
        DropdownSelectionComponent,
      StatusContextualMenuComponent,
    ],
  entryComponents: [ActionListItemComponent, IssueListItemComponent, ActionDetailModalComponent]
})
export class SharedModule {
  static forChild(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TimezoneInterceptor,
          multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
      ]
    };
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LocalizationService,
        AuthorizationService,
        LocalStorageService,
        UserPreferencesService,
        TokenService,
        RefreshTokenService,
        ErrorLogService,
        ActionsService,
        IssuesService,
        PhotoViewerService,
        InterventionTeamsService,
        ContactsService,
        AddressFormatService,
        AppAvailableLanguagesService,
        HttpHeadersService,
        AccountSiteService,
        AuthenticationService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TimezoneInterceptor,
          multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
      ]
    };
  }
}
